module.exports = __webpack_public_path__ + "img/apple.ad073357.png";